/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export interface DebugBar {
  content: { [key: string]: string };
  contentOrder: string[];
  externalCalls: ExternalCall[];
}

export interface DebugBar_ContentEntry {
  key: string;
  value: string;
}

export interface ExternalCall {
  type: string;
  url: string;
  request: string;
  response: string;
  wonderlandUrl: string;
}

function createBaseDebugBar(): DebugBar {
  return { content: {}, contentOrder: [], externalCalls: [] };
}

export const DebugBar = {
  encode(
    message: DebugBar,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    Object.entries(message.content).forEach(([key, value]) => {
      DebugBar_ContentEntry.encode(
        { key: key as any, value },
        writer.uint32(10).fork()
      ).ldelim();
    });
    for (const v of message.contentOrder) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.externalCalls) {
      ExternalCall.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DebugBar {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDebugBar();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          const entry1 = DebugBar_ContentEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.content[entry1.key] = entry1.value;
          }
          break;
        case 2:
          message.contentOrder.push(reader.string());
          break;
        case 3:
          message.externalCalls.push(
            ExternalCall.decode(reader, reader.uint32())
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DebugBar {
    return {
      content: isObject(object.content)
        ? Object.entries(object.content).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
              acc[key] = String(value);
              return acc;
            },
            {}
          )
        : {},
      contentOrder: Array.isArray(object?.contentOrder)
        ? object.contentOrder.map((e: any) => String(e))
        : [],
      externalCalls: Array.isArray(object?.externalCalls)
        ? object.externalCalls.map((e: any) => ExternalCall.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DebugBar): unknown {
    const obj: any = {};
    obj.content = {};
    if (message.content) {
      Object.entries(message.content).forEach(([k, v]) => {
        obj.content[k] = v;
      });
    }
    if (message.contentOrder) {
      obj.contentOrder = message.contentOrder.map((e) => e);
    } else {
      obj.contentOrder = [];
    }
    if (message.externalCalls) {
      obj.externalCalls = message.externalCalls.map((e) =>
        e ? ExternalCall.toJSON(e) : undefined
      );
    } else {
      obj.externalCalls = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<DebugBar>): DebugBar {
    const message = createBaseDebugBar();
    message.content = Object.entries(object.content ?? {}).reduce<{
      [key: string]: string;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = String(value);
      }
      return acc;
    }, {});
    message.contentOrder = object.contentOrder?.map((e) => e) || [];
    message.externalCalls =
      object.externalCalls?.map((e) => ExternalCall.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDebugBar_ContentEntry(): DebugBar_ContentEntry {
  return { key: "", value: "" };
}

export const DebugBar_ContentEntry = {
  encode(
    message: DebugBar_ContentEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): DebugBar_ContentEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDebugBar_ContentEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DebugBar_ContentEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? String(object.value) : "",
    };
  },

  toJSON(message: DebugBar_ContentEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },

  fromPartial(
    object: DeepPartial<DebugBar_ContentEntry>
  ): DebugBar_ContentEntry {
    const message = createBaseDebugBar_ContentEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseExternalCall(): ExternalCall {
  return { type: "", url: "", request: "", response: "", wonderlandUrl: "" };
}

export const ExternalCall = {
  encode(
    message: ExternalCall,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.request !== "") {
      writer.uint32(26).string(message.request);
    }
    if (message.response !== "") {
      writer.uint32(34).string(message.response);
    }
    if (message.wonderlandUrl !== "") {
      writer.uint32(42).string(message.wonderlandUrl);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExternalCall {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExternalCall();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.type = reader.string();
          break;
        case 2:
          message.url = reader.string();
          break;
        case 3:
          message.request = reader.string();
          break;
        case 4:
          message.response = reader.string();
          break;
        case 5:
          message.wonderlandUrl = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ExternalCall {
    return {
      type: isSet(object.type) ? String(object.type) : "",
      url: isSet(object.url) ? String(object.url) : "",
      request: isSet(object.request) ? String(object.request) : "",
      response: isSet(object.response) ? String(object.response) : "",
      wonderlandUrl: isSet(object.wonderlandUrl)
        ? String(object.wonderlandUrl)
        : "",
    };
  },

  toJSON(message: ExternalCall): unknown {
    const obj: any = {};
    message.type !== undefined && (obj.type = message.type);
    message.url !== undefined && (obj.url = message.url);
    message.request !== undefined && (obj.request = message.request);
    message.response !== undefined && (obj.response = message.response);
    message.wonderlandUrl !== undefined &&
      (obj.wonderlandUrl = message.wonderlandUrl);
    return obj;
  },

  fromPartial(object: DeepPartial<ExternalCall>): ExternalCall {
    const message = createBaseExternalCall();
    message.type = object.type ?? "";
    message.url = object.url ?? "";
    message.request = object.request ?? "";
    message.response = object.response ?? "";
    message.wonderlandUrl = object.wonderlandUrl ?? "";
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
